import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormControl, Validators,FormGroup} from '@angular/forms';

import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {

	resendFormSubmitted = false
  confirmEmailForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  constructor(private _authService: AuthService, private _router: Router) { }

  ngOnInit() {
  }

  resend() {
  	this._authService.resendConfrimationEmail(this.confirmEmailForm.value).subscribe((result) => {
  		this.resendFormSubmitted = true
  	})
  }

}
